import { IMG } from '../../const';
import './hidden-cards.scss';

const HiddenCardsBlock = ({ setSelectedSection, openReportExample }) => {
  const onSetActiveSection = () => {
    setSelectedSection('how-it-works');
  };

  return (
    <div className="hidden-cards-block">
      <div>
        <button
          type="button"
          onClick={onSetActiveSection}
          className="hidden-card__button"
        >
          How it works?
        </button>
        <div className="hidden-card__wrapper">
          <picture>
            <source
              srcSet={`${IMG.QUICK_QUOTE}/how-cost-calculator-works.avif`}
              type="image/avif"
            />
            <source
              srcSet={`${IMG.QUICK_QUOTE}/how-cost-calculator-works.webp`}
              type="image/webp"
            />
            <source
              srcSet={`${IMG.QUICK_QUOTE}/how-cost-calculator-works.png`}
              type="image/png"
            />
            <img
              src={`${IMG.QUICK_QUOTE}/how-cost-calculator-works.png`}
              alt="How it works"
              width="108"
              height="138"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
      <div>
        <button
          type="button"
          className="hidden-card__button"
          onClick={openReportExample}
        >
          Review an example
        </button>
        <div className="hidden-card__wrapper">
          <picture>
            <source
              srcSet={`${IMG.QUICK_QUOTE}/app-estimations.avif`}
              type="image/avif"
            />
            <source
              srcSet={`${IMG.QUICK_QUOTE}/app-estimations.webp`}
              type="image/webp"
            />
            <source
              srcSet={`${IMG.QUICK_QUOTE}/app-estimations.png`}
              type="image/png"
            />
            <img
              src={`${IMG.QUICK_QUOTE}/app-estimations.png`}
              alt="How it works"
              width="108"
              height="138"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default HiddenCardsBlock;
